import { render, staticRenderFns } from "./auctionDialog.vue?vue&type=template&id=0c835884&scoped=true"
import script from "./auctionDialog.vue?vue&type=script&lang=js"
export * from "./auctionDialog.vue?vue&type=script&lang=js"
import style0 from "./auctionDialog.vue?vue&type=style&index=0&id=0c835884&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c835884",
  null
  
)

export default component.exports